import { baseApi, TAGS } from 'shared/api';
import type { BaseResponse } from 'shared/models/common';

import { getMarkAsReadEndpoint } from './helpers/getMarkAsReadEndpoint';
import type { EventMessage } from './types';

export const eventsListApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getEventsList: build.query<EventMessage[], string>({
      query: (cooperativeId) => ({
        url: `/user/cooperatives/${cooperativeId}/events`,
        method: 'GET',
      }),
      providesTags: [TAGS.EVENTS_LIST],
      transformResponse: (response: BaseResponse<EventMessage[]>) =>
        response.Data,
    }),
    readEventMessages: build.mutation<void, string[]>({
      query: (eventMessagesIds) => ({
        url: getMarkAsReadEndpoint(eventMessagesIds),
        method: 'PUT',
      }),
      invalidatesTags: [TAGS.EVENTS_LIST],
    }),
  }),
});
